import React from 'react';
import { Link, useNavigate, useLocation, matchPath } from 'react-router-dom';
import { clearAuth, getAuth, isCompanyAdmin } from '../authStorage';

function NavRouteLink({ to, end, children, adminTheme }) {
  const { pathname } = useLocation();
  const pattern = typeof to === 'string' ? { path: to, end: !!end } : to;
  const active = !!matchPath(pattern, pathname);
  return (
    <Link
      to={to}
      className={
        adminTheme
          ? active
            ? 'app-navbar__link app-navbar__link--active'
            : 'app-navbar__link'
          : active
            ? 'app-navbar__link app-navbar__link--active app-navbar__link--contractor-active'
            : 'app-navbar__link app-navbar__link--contractor'
      }
      aria-current={active ? 'page' : undefined}
    >
      {children}
    </Link>
  );
}

/** @param {{ adminTheme?: boolean }} props */
const Navbar = ({ adminTheme = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = getAuth();
  const admin = adminTheme || isCompanyAdmin();

  function logout() {
    clearAuth();
    navigate('/login');
  }

  const ganttTo = (() => {
    try {
      const id = sessionStorage.getItem('ganttLastProjectId');
      if (!id) return '/progress';
      const tid = sessionStorage.getItem('ganttLastTeamId');
      const q = `?project=${encodeURIComponent(id)}`;
      return tid ? `/gantt${q}&team=${encodeURIComponent(tid)}` : `/gantt${q}`;
    } catch {
      return '/progress';
    }
  })();

  const ganttActive = location.pathname === '/gantt';

  return (
    <nav
      className={admin ? 'app-navbar app-navbar--dark' : 'app-navbar app-navbar--light'}
      aria-label="Điều hướng chính"
    >
      <div className="app-navbar__inner">
        {admin && (
          <>
            <NavRouteLink to="/projects" end={false} adminTheme>
              Dự án
            </NavRouteLink>
            <NavRouteLink to="/tasks" end adminTheme>
              Công việc
            </NavRouteLink>
          </>
        )}
        <NavRouteLink to="/progress" end adminTheme={admin}>
          Tiến độ
        </NavRouteLink>
        <Link
          to={ganttTo}
          className={
            admin
              ? ganttActive
                ? 'app-navbar__link app-navbar__link--active'
                : 'app-navbar__link'
              : ganttActive
                ? 'app-navbar__link app-navbar__link--active app-navbar__link--contractor-active'
                : 'app-navbar__link app-navbar__link--contractor'
          }
          aria-current={ganttActive ? 'page' : undefined}
        >
          Biểu đồ Gantt
        </Link>
        {admin && (
          <NavRouteLink to="/admin/pending-registrations" end adminTheme>
            Duyệt đăng ký
          </NavRouteLink>
        )}
        <span className="app-navbar__spacer" />
        {auth?.user && <span className="app-navbar__user">{auth.user.username}{admin ? ' · quản trị' : ''}</span>}
        <button type="button" className="app-navbar__logout" onClick={logout}>
          Đăng xuất
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
